import React from 'react'
import { useLocation } from 'react-router-dom'
import { FiltersState, Filter } from '../store/store'
import AddSubscription from './AddSubscription'
import { useTranslation } from 'react-i18next'
import ContentHeader from '../../../components/layout/ContentHeader'
import HeaderActions from '../../../components/layout/HeaderActions'
import HeaderTitle from '../../../components/layout/HeaderTitle'

import './SubscriptionsFilterBar.css'

type Props = {
  subscriptionCount: number
  filters: FiltersState
  filterPanelOpen: boolean
  setFilterPanelOpen: (open: boolean) => void
}

function SubscriptionsFilterBar(props: Props) {
  const { filters, filterPanelOpen, setFilterPanelOpen, subscriptionCount } = props
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const filterId = params.get('filter')
  const filter = (filters && filterId) ? filters.filters.find((f: Filter) => f.id === filterId) : null

  const { t } = useTranslation(['subscriptions','global'])

  const filterName = filter ? filter.name : t('active_subscriptions')


  function openModal() {
    setFilterPanelOpen(!filterPanelOpen)
  }

  return (
    <ContentHeader>
      <HeaderTitle>
        <b>{filterName}</b>&nbsp;
        {subscriptionCount > 0 && (
          <b>({subscriptionCount})</b>
        )}
      </HeaderTitle>

      <HeaderActions>
        <AddSubscription />

        <div className="pill" id="filter-btn" onClick={openModal}>
          <i className="fas fa-filter icon-spacing"></i>
          <span>{t('buttons.filter')}</span>
        </div>

      </HeaderActions>
    </ContentHeader>
  )
}

export default SubscriptionsFilterBar
